module.exports = new __parcel__URL__("litepaper_1_gameplay_text.923d81f4.png").toString();